import { useEffect } from 'react';
import { createFrameClock, smoothingFactor } from '../lib/timeSmoothing.js';

// How quickly the glow eases toward the cursor: the old per-frame 12% lerp at
// 120Hz, as a time constant (−(1/120) / ln 0.88 ≈ 0.065s). Measured in time, so
// every refresh rate covers 90% of a jump in about 150ms.
const FOLLOW_EASE_SECONDS = 0.065;

export function useCursorGlow() {
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hoverCapable = window.matchMedia('(hover: hover)').matches;
    if (prefersReducedMotion || !hoverCapable) return;

    const glow = document.createElement('div');
    glow.className = 'cursor-glow';
    document.body.appendChild(glow);

    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    let tx = mx;
    let ty = my;
    const onMove = (e) => {
      tx = e.clientX;
      ty = e.clientY;
    };
    window.addEventListener('mousemove', onMove, { passive: true });

    const frameSeconds = createFrameClock();
    let rafId = 0;
    const tick = (now) => {
      rafId = requestAnimationFrame(tick);
      const follow = smoothingFactor(frameSeconds(now), FOLLOW_EASE_SECONDS);
      mx += (tx - mx) * follow;
      my += (ty - my) * follow;
      glow.style.setProperty('--mx', mx + 'px');
      glow.style.setProperty('--my', my + 'px');
    };
    rafId = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('mousemove', onMove);
      glow.remove();
    };
  }, []);
}
